export default function calculateIsOverConsentQuota({ consentQuota, consentsCount }) {
  // eslint-disable-next-line eqeqeq
  if ( consentQuota == null || consentsCount == null ) {
    console.warn('Consent quota information missing. Treating as if consent quota not exceeded.')
    return false
  }

  return ( consentsCount > consentQuota )
}
